
/**
 * Main Logo file name (with extension)
 * Should be in the same folder as this file.
 * Use biggest and best logo available, will be sized accordingly.
 */
import MAIN_LOGO_FILE from "./MF-PanoramicSmall.png";

/**
 * Main component colour for ant design
 * This MUST match the --component-primary-colour variable in index-variables.css
 */
export const dpComponentColour = "rgb(99, 235, 245)";

export const dpPanelColour = "rgb(255, 255, 255)";

/* DO NOT CHANGE */
export const MAIN_LOGO = MAIN_LOGO_FILE;